<span class="text-3xl">{{ 'targets.title' | translate }}</span>

<p>{{ 'targets.description' | translate }}</p>
<button
  kendoButton
  themeColor="primary"
  class="uppercase"
  maximizerShowcaseBookDemo
>
  {{ 'targets.button.action' | translate }}
</button>
